import { prog } from '../../../motion'
import { useCopy } from '../../i18n'
import codeknacker from '../../showcase/media/game-codeknacker.mp4'
import gefuehlschaosPoster from '../../showcase/media/game-gefuehlschaos.jpg'
import gefuehlschaos from '../../showcase/media/game-gefuehlschaos.mp4'
import hochstaplerPoster from '../../showcase/media/game-hochstapler.jpg'
import hochstapler from '../../showcase/media/game-hochstapler.mp4'
import selbsterkenntnisPoster from '../../showcase/media/game-selbsterkenntnis.jpg'
import selbsterkenntnis from '../../showcase/media/game-selbsterkenntnis.mp4'
import taetigkeitsvielfaltPoster from '../../showcase/media/game-taetigkeitsvielfalt.jpg'
import taetigkeitsvielfalt from '../../showcase/media/game-taetigkeitsvielfalt.mp4'
import { ScrollVideo } from '../../showcase/stage/fx'
import { C, Shape } from '../shapes'

// Jedes Spiel in einer anderen Aivy-Form, dahinter dieselbe Form flach in Farbe
const CLIPS = [
  { src: codeknacker, kind: 'circle', color: C.green },
  { src: hochstapler, poster: hochstaplerPoster, kind: 'tri', color: C.pink },
  {
    src: gefuehlschaos,
    poster: gefuehlschaosPoster,
    kind: 'square',
    color: C.yellow
  },
  {
    src: selbsterkenntnis,
    poster: selbsterkenntnisPoster,
    kind: 'arch',
    color: C.blue
  },
  {
    src: taetigkeitsvielfalt,
    poster: taetigkeitsvielfaltPoster,
    kind: 'quarter',
    color: C.pink
  }
]

const STAT_SHAPES = [
  ['circle', C.pink],
  ['square', C.green],
  ['tri', C.yellow]
]

// Bereich, in dem die Strecke von rechts nach links fährt
const RUN = [0.08, 0.94]

/**
 * Horizontale Strecke: Titel, fünf echte Spiel-Clips in Form-Masken, am Ende
 * die Zahlen zur Candidate Experience.
 */
export default function PlGames() {
  const c = useCopy('spiele')

  return (
    <div className='ap-games'>
      <svg width='0' height='0' className='ap-defs' aria-hidden='true'>
        <defs>
          <clipPath id='ap-clip-tri' clipPathUnits='objectBoundingBox'>
            <path d='M.5.03c.04 0 .07.02.09.05l.39.76c.04.07-.01.16-.09.16H.11C.03 1-.02.91.02.84L.41.08C.43.05.46.03.5.03Z' />
          </clipPath>
        </defs>
      </svg>

      <div className='ap-games__track' style={prog(RUN)}>
        <div className='ap-games__intro'>
          <h2 className='ap-display ap-display--md'>
            {c.title.map((line) => (
              <span key={line} className='ap-line'>
                {line}
              </span>
            ))}
          </h2>
          <p className='ap-lead'>{c.sub}</p>
        </div>

        {CLIPS.map((clip, i) => {
          const g = c.games[i]
          return (
            <figure
              key={g.name}
              className={`ap-game ap-game--${clip.kind}`}
              style={{ '--c': clip.color, '--i': i }}
            >
              <div className='ap-game__frame'>
                <span className='ap-game__back' />
                <span className='ap-game__mask'>
                  <ScrollVideo
                    src={clip.src}
                    poster={clip.poster}
                    at={[0.001, 0.999]}
                    className='ap-game__video'
                    label={g.name}
                  />
                </span>
              </div>
              <figcaption>
                <span className='ap-game__name'>{g.name}</span>
                <span className='ap-game__meta'>
                  {g.dim} · {g.time}
                </span>
              </figcaption>
            </figure>
          )
        })}

        <div className='ap-games__stats'>
          {c.stats.map((s, i) => (
            <div key={s.label} className='ap-games__stat'>
              <Shape
                kind={STAT_SHAPES[i][0]}
                color={STAT_SHAPES[i][1]}
                size={34}
              />
              <span className='ap-games__stat-num'>{s.value}</span>
              <span className='ap-games__stat-label'>{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
